import { render, staticRenderFns } from "./ReviewConfirmationModal.vue?vue&type=template&id=5b369d07&scoped=true&"
import script from "./ReviewConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./ReviewConfirmationModal.vue?vue&type=script&lang=js&"
import style0 from "./ReviewConfirmationModal.vue?vue&type=style&index=0&id=5b369d07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b369d07",
  null
  
)

export default component.exports